export interface SymbolLookupFocusOutPolicyOptions {
  readonly isValidSymbol: boolean;
  readonly checkSymbol: boolean;
  readonly targetId?: string;
  readonly targetType?: string | null;
  readonly relatedTarget: EventTarget | null;
}

/**
 * Keeps SymbolLookup focusout auto-select behavior as a pure policy.
 */
export function shouldAutoSelectOnFocusOut(options: SymbolLookupFocusOutPolicyOptions): boolean {
  const {
    isValidSymbol,
    checkSymbol,
    targetId,
    targetType,
    relatedTarget
  }: SymbolLookupFocusOutPolicyOptions = options;

  if (!isValidSymbol || checkSymbol) {
    return false;
  }

  const blurredInputWithoutButtonFocus = targetId === 'symbolInput' && relatedTarget === null;
  const blurredSearchButton = targetType === 'button';

  return blurredInputWithoutButtonFocus || blurredSearchButton;
}

